<template>
  <div>
    <h1>Editar File</h1>
    <b-card>
      <FormEdit @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import FormEdit from "../Components/FormEdit.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { FormEdit },
  computed: {
    ...mapState("files", ["file"]),
  },
  methods: {
    ...mapActions("files", ["ActionNewFile", "ActionShow"]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "files_list" });
      }
    },
  },
  async created() {
    this.ActionNewFile();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
